<template>
	<div class="app-content">
		<AppPageTitle></AppPageTitle>
		<Content class="app-content__main">
			<TableFuncs>
				<Button type="primary" icon="ios-add-circle-outline" @click="addShow">新增日期图片</Button>
			</TableFuncs>
			<Table border :columns="queryColumn" :loading="loading" :data="queryData" ref="dataTable" center>
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" @click="editData(row)">编辑</Button>
					<Button type="error" size="small" style="margin-right: 5px" @click="delData(row.id)">删除</Button>
				</template>
			</Table>
			<Row>
				<Col :md="24" class="pagination">
				<Page :total="totalRecord" :page-size="pageSize" :current="pageNum" :disabled="loading"
					@on-change="pageChange" @on-page-size-change="pageSizeChange" show-elevator show-sizer show-total />
				</Col>
			</Row>
		</Content>
		<Modal v-model="addStoreShow" :title="addForm.id?'编辑日期图片':'新增日期图片'">
			<Form ref="addForm" :model="addForm" :label-width="120" :rules="addRule">
				<FormItem label="选择渠道:" prop="storeIds">
					<Select v-model="addForm.storeIds" clearable style="width: 100%;" multiple>
						<Option v-for="item in storeList" :value="item.id" :key="item.id">{{ item.storeName }}</Option>
					</Select>
				</FormItem>
				<FormItem label="图片日期" prop="picDay">
					<DatePicker type="date" :value="addForm.picDay"  @on-change="dateChange" format="yyyyMMdd" placement="bottom-end"
						placeholder="请选择" clearable />
				</FormItem>
				<FormItem label="上传图片" prop="picUrl">
					<Upload :action="uploadFile" name="file" :on-success="uploadCallback" :default-file-list="fileList"
						:data="uploadData" accept="image/*">
						<Button icon="ios-cloud-upload-outline">上传文件</Button>
					</Upload>
				</FormItem>
				<FormItem label="跳转链接" prop="linkUrl">
					<Input v-model="addForm.linkUrl" placeholder="填写跳转链接"></Input>
				</FormItem>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="addOrUpdateData">确认提交</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
	import api from '../../api'
	import QueryCondition from '../../components/statistics/QueryCondition'
	import TableFuncs from '../../components/statistics/TableFuncs'
	export default {
		components: {
			QueryCondition,
			TableFuncs
		},
		data() {
			return {
				uploadFile: api.statistics.uploadFile,
				fileList: [],
				uploadData: { filePath: 'img' },
				loading: false,
				queryData: [],
				storeList:[],
				totalRecord: 1,
				pageNum: 1,
				pageSize: 10,
				addStoreShow: false,
				addForm: {
					storeIds:[],
					picDay: '',
					picUrl: '',
					picName: '',
					linkUrl:''
				},
				addRule: {
					storeIds: [
						{ required: true, message: '请选择渠道', trigger: 'blur',type:'array' }
					],
					picDay: [
						{ required: true, message: '请选择日期', trigger: 'blur' }
					],
					picUrl: [
						{ required: true, message: '请上传图片', trigger: 'blur' },
					],
					
				}
			}
		},
		computed: {

			queryColumn() {
				return [{
						type: 'index',
						width: 60,
						align: 'center'
					},
					{
						title: '图片显示日期',
						key: 'picDay',
						align: 'center'
					},
					{
						title: '图片链接',
						key: 'picUrl',
						align: 'center'
					},
					{
						title: '跳转链接',
						key: 'linkUrl',
						align: 'center'
					},
					{
						title: '渠道',
						key: 'storeNames',
						align: 'center'
					},
					{
						title: '创建时间',
						key: 'createTime',
						align: 'center'
					},
					{
						title: '操作',
						slot: 'action',
						width: 300,
						align: 'center'
					}

				]
			}
		},
		created() {
			this.getData();
			this.getAppStore()
		},
		methods: {
			refreshData() {
				this.pageNum = 1
				this.queryData = []
				this.getData()
			},
			getAppStore() {				
				api.statistics
					.getAllUsedStores({})
					.then(res => {
						const result = res.data || {}
						this.storeList = result
					})
			},
			getData() {
				this.loading = true
				const queryParams = {
					page: this.pageNum,
					limit: this.pageSize
				}
				api.statistics
					.getDayPicPage(queryParams)
					.then(res => {
						const result = res.data || {}
						this.totalRecord = result.totalRecordNum || 0
						this.queryData = result.records
					})
					.catch(err => {
						this.$Message.error('获取数据失败: ' + err.message)
					})
					.then(() => {
						this.loading = false
					})
			},
			pageChange(pageNum) {
				this.pageNum = pageNum
				this.getData()
			},
			pageSizeChange(pageSize) {
				this.pageSize = pageSize
				this.pageNum === 1 ? this.getData() : (this.pageNum = 1)
			},
			addOrUpdateData() {
				const that = this
				console.log(this.addForm)
				that.$refs['addForm'].validate((valid) => {
					if (valid) {
						let params = { ...that.addForm }
						api.statistics
							.addOrEditDayPic(params)
							.then(res => {
								that.$Message.success('Success!');
								if (that.addForm.id) {
									//编辑
									that.queryData.forEach(item => {
										if (item.id == that.addForm.id) {
											item.picDay = that.addForm.picDay
											item.picUrl = that.addForm.picUrl
											item.linkUrl=that.addForm.linkUrl
											let storeNameArr=[]
											that.storeList.forEach(item=>{
												if(that.addForm.storeIds.indexOf(item.id)>-1){
													storeNameArr.push(item.storeName)
												}
											})
											item.storeNames=storeNameArr.join(",")
											
										}
									})
								} else {
									//新增
									that.refreshData()
								}
								that.addStoreShow = false
							})
							.catch(err => {
							})

					}
				})
			},
			delData(id) {
				const that = this
				that.$Modal.confirm({
					title: '操作确认',
					content: '数据删除不可恢复，确定删除吗？',
					onOk: function() {
						api.statistics
							.delDayPic({ 'id': id })
							.then(res => {
								that.$Message.success('Success!');
								that.refreshData()
							})
					}
				})

			},

			addShow() {
				this.addForm = {
					storeIds:[],
					picDay: '',
					picUrl: '',
					picName: '',
					linkUrl:'',
				}
				this.fileList=[]
				this.addStoreShow = true
			},
			editData(rowData) {
				this.addForm = {
					id: rowData.id,
					storeIds:rowData.storeIds?rowData.storeIds.split(","):[],
					picDay: rowData.picDay,
					picUrl: rowData.picUrl,
					picName: rowData.picName,
					linkUrl:rowData.linkUrl,
				}
				this.fileList=[{
					name: rowData.picName,
					url: rowData.picUrl
				}]
				this.addStoreShow = true

			},
			uploadCallback(response, file, fileList) {
				this.addForm.picUrl = response.data.url
				this.addForm.picName=response.data.fileName,
				this.fileList = [{
					name: response.data.fileName,
					url: response.data.url
				}]
			},
			dateChange(dateStr,date){
				this.addForm.picDay=dateStr
			}
		},



	}
</script>
